import React from 'react';
import { FaUsers, FaChalkboardTeacher, FaUserGraduate, FaClock } from 'react-icons/fa';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';

const stats = [
    { 
        icon: <FaUsers />, 
        count: 27000, 
        label: "USERS AFFECTED", 
        suffix: "+",
        gradient: "from-blue-600 to-blue-800"
    },
    { 
        icon: <FaChalkboardTeacher />, 
        count: 290, 
        label: "MENTORS", 
        suffix: "+",
        gradient: "from-purple-600 to-purple-800"
    },
    { 
        icon: <FaUserGraduate />, 
        count: 8000, 
        label: "MENTEES", 
        suffix: "+",
        gradient: "from-green-600 to-green-800"
    },
    { 
        icon: <FaClock />, 
        count: 2700, 
        label: "DURATION (HRS)", 
        suffix: " Hrs",
        gradient: "from-orange-600 to-orange-800"
    }
];

const StatCard = ({ icon, count, label, suffix, gradient, inView }) => (
    <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="relative group"
    >
        <div className="absolute inset-0 bg-gradient-to-br from-gray-100 to-gray-200 rounded-2xl transform rotate-3 transition-transform group-hover:rotate-6"></div>
        <div className="relative bg-white rounded-2xl p-8 shadow-lg transition-all duration-300 group-hover:shadow-xl">
            <div className="flex flex-col items-center">
                <div className={`h-16 w-16 bg-gradient-to-br ${gradient} rounded-2xl flex items-center justify-center mb-6 transform transition-transform group-hover:scale-110`}>
                    <span className="text-3xl text-white">{icon}</span>
                </div>
                <h1 className="text-2xl font-bold text-gray-800 mb-2">
                    {inView ? (
                        <CountUp 
                            end={count} 
                            duration={2.5} 
                            separator="," 
                            suffix={suffix}
                            className="bg-gradient-to-r from-primary-color to-secondary-color bg-clip-text text-transparent"
                        />
                    ) : (
                        count.toLocaleString() + suffix
                    )}
                </h1>
                <h2 className="text-base font-medium text-gray-600 tracking-wider">{label}</h2>
            </div>
        </div>
    </motion.div>
);

const JourneySoFar = () => {
    const { ref, inView } = useInView({ triggerOnce: true });

    return (
        <div ref={ref} className="my-20 mx-auto text-center max-w-[1200px] px-4">
            <motion.h1 
                className="text-3xl font-bold mb-16"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
            >
                <span className="text-primary-color">Our Journey</span>{" "}
                <span className="text-secondary-color">So Far</span>
            </motion.h1>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
                {stats.map((stat, idx) => (
                    <StatCard
                        key={idx}
                        {...stat}
                        inView={inView}
                    />
                ))}
            </div>
        </div>
    );
};

export default JourneySoFar;
